import { isPlatformBrowser } from '@angular/common';
import { Component, EventEmitter, Inject, Output, PLATFORM_ID } from '@angular/core';
import { RouterLink, Router } from '@angular/router';
import { SharedServiceService } from 'app/core/shared-services/shared-service.service';
import { NetworkPanelComponent } from 'app/modules/network_panel/network_panel.component';
import { AuthService } from 'app/core/auth/auth.service';
import { StrapiService } from 'app/core/shared-services/strapi.service';
import { lastValueFrom } from 'rxjs';

@Component({
    standalone: true,
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    imports: [RouterLink, NetworkPanelComponent],
})
export class FooterComponent {

    // -----------------------------------------------------------------------------------------------------
    // @ Outputs
    // -----------------------------------------------------------------------------------------------------
    @Output() focusInput = new EventEmitter<void>();

    // -----------------------------------------------------------------------------------------------------
    // @ Public Variables
    // -----------------------------------------------------------------------------------------------------
    public companyInfoHeader: any = null;

    // -----------------------------------------------------------------------------------------------------
    // @ Constructor
    // -----------------------------------------------------------------------------------------------------
    constructor(
        private _strapiService: StrapiService,
        private router: Router,
        private _sharedService: SharedServiceService,
        private _authService: AuthService,
        @Inject(PLATFORM_ID) private platformId: any
    ) { }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle Hooks
    // -----------------------------------------------------------------------------------------------------
    ngOnInit(): void {
        this.getCompanyInfoHeader();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Get the current year
     */
    get currentYear(): number {
        return new Date().getFullYear();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public Methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Redirect to WhatsApp
     */
    public redirectToWhatsApp(): void {
        if (isPlatformBrowser(this.platformId)) {
            window.open(
                'https://api.whatsapp.com/send/?phone=+27824805401&text=Please+can+you+assist+mee',
                '_blank'
            );
        }
    }

    /**
     * Emit focus to parent input
     */
    public focusOnParentInput(): void {
        this.focusInput.emit();
    }

    /**
     * Scroll to top on route activation
     */
    public onActivate(event: any): void {
        if (isPlatformBrowser(this.platformId)) {
            window.scroll({
                top: 0,
                left: 0,
                behavior: 'smooth',
            });
        }
    }

    /**
     * Open support page for products
     */
    public openSupportProducts(): void {
        localStorage.setItem('catType', 'Products');

        if (localStorage.getItem('catType')) {
            this.router.navigate(['/support']);
        }
    }

    /**
     * Check if user is authenticated and redirect accordingly
     */
    public checkUsage(): void {
        if (this._authService._authenticated) {
            this.router.navigate(['/dashboard']);
        } else {
            this.router.navigate(['/sign-in']);
        }
    }

    /**
     * Get company info header from Strapi
     */
    public async getCompanyInfoHeader(): Promise<void> {
        try {
            const res: any = await lastValueFrom(this._strapiService.getCompanyInfoHeader());
            this.companyInfoHeader = res?.data;
        } catch (error) {
            // Optional: handle error (e.g. log or show alert)
        }
    }
}
